import React from "react";
import { BoxIcon } from "lucide-react";
type StatTileProps = {
  label: string;
  value: string;
  hint?: string;
  icon: BoxIcon;
};
export function StatTile({
  label,
  value,
  hint,
  icon: Icon
}: StatTileProps) {
  return <div className="rounded-xl border bg-card p-4" data-id="element-627" data-mp="1kdoidmlsp6a2">
      <div className="flex items-center justify-between" data-id="element-628" data-mp="1fg64dhsx80v7">
        <p className="text-xs font-medium text-muted-foreground" data-id="element-629" data-mp="1fgpnh1ub4vat">{label}</p>
        <Icon className="size-4 text-muted-foreground" aria-hidden="true" data-id="element-630" data-mp="rrdfu6emovam" />
      </div>
      <p className="mt-2 text-2xl font-semibold tracking-tight tabular-nums" data-id="element-631" data-mp="ms0k0w5s4dvw">{value}</p>
      {hint && <p className="mt-0.5 text-xs text-muted-foreground" data-id="element-632" data-mp="11gev1udcn8nj">{hint}</p>}
    </div>;
}